<template>
  <div>
    <p class="title-page">Despesa por CNPJ</p>
    <TableDespesa />
  </div>
</template>

<script>
import TableDespesa from "../components/TableDespesa.vue";

export default {
  name: "TableDespesaCnpj",

  components: {
    TableDespesa
  }
};
</script>
